import { FlowGroup, PlanStep } from './types';

export function groupPlanSteps(steps: PlanStep[]): FlowGroup[] {
  const groups: FlowGroup[] = [];
  let i = 0;
  while (i < steps.length) {
    const step = steps[i];
    if (step.node_type === 'check') {
      const branches: Array<{ step: PlanStep; idx: number }> = [];
      let j = i + 1;
      while (j < steps.length && (steps[j].node_type === 'conditional' || steps[j].node_type === 'followup')) {
        branches.push({ step: steps[j], idx: j });
        j++;
      }
      groups.push({ kind: 'check', check: step, checkIdx: i, branches });
      i = j;
    } else {
      groups.push({ kind: 'action', step, idx: i });
      i++;
    }
  }
  return groups;
}

export function planStepLabel(step: PlanStep): string {
  const raw = step.reason ?? step.tool ?? '';
  const colon = raw.indexOf(':');
  const text = (colon !== -1 && colon < 9) ? raw.slice(colon + 1).trim() : raw;
  return text.length > 64 ? text.slice(0, 61) + '…' : (text || step.tool);
}

export function toolShort(tool: string): string {
  return tool.replace(/^internal__/, '').replace(/_/g, ' ');
}

export const TOOL_LABELS: Record<string, string> = {
  developer_teams: 'Developer Teams',
  developer_projects: 'Developer Projects',
  iam__get_roles: 'Get IAM Roles',
  iam__update_team_roles: 'Update Team Roles',
  create_dev_team: 'Create Developer Team',
  update_developer_teams: 'Update Developer Teams',
  devs_team: 'Developer Team Members',
  projects: 'Projects',
  api_catalog__init_repo: 'Initialize API Repository',
  api_catalog__push_repo: 'Push to API Repository',
  api_catalog__list: 'List API Catalog',
  api_catalog__get: 'Get API from Catalog',
  unittest__config: 'Configure Unit Tests',
  unittest__documentation: 'Unit Test Documentation',
  unittest__run: 'Run Unit Tests',
  publishing__publish_virtual_api: 'Publish Virtual API',
  publishing__unpublish_api: 'Unpublish API',
  publishing__list: 'List Publications',
};

export function fmtId(id?: string): string {
  if (!id) return '';
  return id.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function fmtTool(raw: string): string {
  const key = raw.replace(/^internal__/, '');
  if (TOOL_LABELS[key]) return TOOL_LABELS[key];
  return key.replace(/__/g, ' · ').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

// Formats a duration in milliseconds as e.g. "3.4s" or "1m 05s".
export function formatElapsed(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '0.0s';
  const totalSeconds = ms / 1000;
  if (totalSeconds < 60) return `${totalSeconds.toFixed(1)}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
}
